import { Controller } from "@hotwired/stimulus"

// Dropdown de conta (top bar). Fecha ao clicar fora.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.onClickOutside = this.onClickOutside.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.toggle("hidden")
    if (!this.panelTarget.classList.contains("hidden")) {
      document.addEventListener("click", this.onClickOutside)
    }
  }

  onClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.panelTarget.classList.add("hidden")
      document.removeEventListener("click", this.onClickOutside)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.onClickOutside)
  }
}
